import { ArrowUpDownIcon } from '@chakra-ui/icons';
import { Container, Flex } from '@chakra-ui/react';
import { Autocomplete } from '../Autocomplete';
import { ChangeEvent, useEffect, useState } from 'react';
import { Option } from 'components/Autocomplete/Autocomplete';

type InputProps = {
    placeholder: string;
    options?: Option[];
    onChange: (value: ChangeEvent) => void;
};

type SwitchableInputProps = {
    inputsProps: [InputProps, InputProps];
};

const SwitchableInput = ({inputsProps}: SwitchableInputProps) => {
    const [inputs, setInputs] = useState<[InputProps, InputProps]>(inputsProps);
    const [values, setValues] = useState<string[]>([]);
    
    useEffect(() =>{
        if ( inputsProps?.[0]?.options) {
            setInputs(inputsProps);
        }
    }, [inputsProps])

    const onRearrange = () => {
        const reversedInputs = [...inputs.reverse()];
        if (values.length === 1) {
            values.push('');
        }
        const valuesReverse = [...values.reverse()];
        setValues(valuesReverse);
        setInputs(reversedInputs as [InputProps, InputProps]);
    };

    return (
        <Container padding={0} position="relative">
          <Flex
            position="absolute"
            right="5%"
            zIndex={1000}
            top="30%"
            paddingTop={2}
            width={10}
            justifyContent="center"
            alignSelf="center"
            cursor="pointer"  
            onClick={onRearrange}
            background="#FBFBFB"
            borderRadius="45px"
            boxShadow="0px 21.164px 42.328px -10.1587px" 
            paddingBottom={2}>
                <ArrowUpDownIcon  />
            </Flex>
     {inputs.map((inputProp, index) => <Container padding={0}>
        <Autocomplete
            //@ts-ignore
            onChange={(value) => { values[index] = value.target.value || ''; inputProp.onChange(value); } }
            placeholder={inputProp.placeholder} onInputChange={() => {}}
            options={inputProp.options || []}
        />
    </Container>)}
     </Container>
    );
}

export {SwitchableInput};